import React from "react";

interface Props {
  paymentMethod: string;
  isCompleted: boolean;
  onPaymentMethodChange: (method: string) => void;
  themeBorderColor: string;
  themeTextColor: string;
  getLightBgClass: () => string;
}

const PaymentMethodSelector: React.FC<Props> = ({ paymentMethod, isCompleted, onPaymentMethodChange, themeBorderColor, themeTextColor, getLightBgClass }) => {
  const methods = [
    { method: "Card", label: "Card" },
    { method: "Cash", label: "Cash" },
  ];

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-1 mb-1.5 mt-1.5 w-full">
      <h3 className="text-base font-semibold text-gray-800 text-center mb-0 tracking-wide">Choose Payment Method</h3>

      <div className="grid grid-cols-2 gap-2">
        {methods.map(({ method, label }) => {
          const isSelected = paymentMethod === method;
          return (
            <label
              key={method}
              className={`flex items-center justify-center gap-1 rounded-lg border px-2 py-1.5 transition-all duration-150 cursor-pointer
                ${isSelected ? `${themeBorderColor} ${getLightBgClass()} shadow-sm scale-[1.01]` : "border-gray-300 hover:border-gray-400 bg-gray-50"}
                ${isCompleted ? "opacity-60 cursor-not-allowed" : ""}
              `}
            >
              <input
                type="radio"
                name="payment-method"
                value={method}
                checked={isSelected}
                onChange={() => onPaymentMethodChange(method)}
                disabled={isCompleted}
                className="w-3.5 h-3.5 cursor-pointer"
              />
              <span className={`text-xs sm:text-sm font-medium ${isSelected ? themeTextColor : "text-gray-700"}`}>{label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default PaymentMethodSelector;